export function applyExperienceV2(definition) {
  if (!definition || typeof definition !== 'object') return definition;
  return structuredClone(definition);
}
